import config from 'react-global-configuration';
import prod from './prod';
import local from './local';

export const isDev = process.env.NODE_ENV === 'development';

let orgConfigModule;

try {
  orgConfigModule = isDev ? require('./dev-organization').default : require('./organization').default;
} catch (e) {
  console.warn('Could not load organization config, falling back to default');
  orgConfigModule = require('./organization').default;
}

export const orgConfig = typeof orgConfigModule === 'function' ? orgConfigModule() : orgConfigModule;

function getUserConfigFromLS() {
  try {
    const raw = localStorage.getItem('userConfig');
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}
const userConfig = getUserConfigFromLS();

if (isDev) {
  config.set(prod, { freeze: false });
  config.set(orgConfig, { assign: true });
  config.set(local, { assign: true });
  config.set(userConfig, { assign: true });
} else {
  config.set(local, { freeze: false });
  config.set(prod, { assign: true });
  config.set(orgConfig, { assign: true });
  config.set(userConfig, { assign: true });
}
